import { ProjectsService } from '@/services';
import DateParser from '@/parsers/date';

const INITIAL_STATE = {
  isLoadingProjects: false,
  isLoadingProject: false,
  isLoadingTasks: false,
  projects: null,
  project: null,
};

const store = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations: {
    SET_PROJECTS(state, value) {
      state.projects = value;
    },

    SET_LOADING_PROJECTS(state, value) {
      state.isLoadingProjects = value;
    },

    SET_LOADING_TASKS(state, value) {
      state.isLoadingTasks = value;
    },

    SET_LOADING_PROJECT(state, value) {
      state.isLoadingProject = value;
    },

    SET_PROJECT_INFO(state, value) {
      state.project = { info: value };
    },

    MERGE_PROJECT_INFO(state, value) {
      state.project.info = {
        ...state.project.info || {},
        ...value,
      };
    },

    SET_PROJECT_BOARDS(state, value) {
      state.project.boards = value;
    },

    UPDATE_PROJECT_BOARD(state, value) {
      const index = state.project.boards.findIndex((item) => item.uid === value.uid);
      const boards = [];

      state.project.boards = boards.map((board, boardIndex) => {
        if (boardIndex === index) {
          return { ...board, title: value.title };
        }

        return board;
      });
    },

    SET_PROJECT_TASKS(state, value) {
      state.project.tasks = value;
    },

    UPDATE_TASK(state, value) {
      const { tasks } = state.project;

      state.project.tasks = tasks.map((task) => {
        if (task.id !== value.id) {
          return task;
        }

        return {
          ...task,
          ...value,
          ...(value.due_date)
            ? { due_date: DateParser.parseFromTimestamp(value.due_date.seconds) }
            : {},
        };
      });
    },
  },
  actions: {
    fetchProjects({ commit }, companyId) {
      commit('SET_LOADING_PROJECTS', true);

      ProjectsService
        .fetchCompanyProjects(companyId)
        .then((projects) => {
          commit('SET_PROJECTS', projects);

          commit('SET_LOADING_PROJECTS', false);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async fetchProjectTasks({ commit }, data) {
      commit('SET_LOADING_TASKS', true);

      try {
        const tasks = await ProjectsService.fetchProjectTasks(data);

        commit('SET_PROJECT_TASKS', tasks);
      } catch (err) {
        console.log(err);
        throw new Error(err);
      }

      commit('SET_LOADING_TASKS', false);
    },
    async updateProjectTasks({ commit }, tasks) {
      commit('SET_PROJECT_TASKS', tasks);
    },
    createProject() {},
    updateProjectInfo({ commit }, data) {
      commit('MERGE_PROJECT_INFO', data);
    },
    async fetchProjectInfo({ dispatch, commit }, data) {
      commit('SET_LOADING_PROJECT', true);

      try {
        const projectInfo = (data.filterByUser)
          ? await ProjectsService.fetchDefaultProjectInfo(data)
          : await ProjectsService.fetchProjectBySlug(data);

        const boards = await ProjectsService.fetchProjectBoards(projectInfo.uid);

        commit('SET_PROJECT_INFO', projectInfo);
        commit('SET_PROJECT_BOARDS', boards);

        dispatch('fetchProjectTasks', {
          ...data,
          projectId: projectInfo.uid,
        });
      } catch (err) {
        console.log(err);
      }

      commit('SET_LOADING_PROJECT', false);
    },

    async updateBoard({ commit }, data) {
      try {
        commit('UPDATE_PROJECT_BOARD', data);
      } catch (err) {
        console.log(err);
      }
    },

    async updateTask({ commit }, task) {
      try {
        await ProjectsService.updateTaskDetails(task);
        commit('UPDATE_TASK', task);
      } catch (err) {
        console.log(err);
      }
    },
  },
};

export default store;
